<div class="container-all" style="margin: 10px;">


  <div class="inputArea">
    <div><h4>Select Resource</h4></div>
    <div class="floatRight">
      <p-dropdown (onChange)="filterResources(selectedResource)" [(ngModel)]="selectedResource" [options]="resources"
                  [style]="{'width':'160px'}" placeholder="Select a Resource"></p-dropdown>
    </div>
  </div>
  <div class="ui-g ui-fluid inputArea">
    <h4>Job Number</h4>
    <div class="ui-g-1 ">
      <input (focusout)="getJob()" [(ngModel)]="selectedJobId" [disabled]="!resourceSelected" pInputText placeholder="0..9"
             type="number">
    </div>
    <h4>Current User</h4>
    <div class="ui-g-1">
      <input (focusout)="getJob()" [(ngModel)]="selectedUser" [disabled]="!resourceSelected" pInputText placeholder="user"
             type="text">
    </div>
    <h4>Name</h4>
    <div class="ui-g-1 ">
      <input (focusout)="getJob()" [(ngModel)]="selectedJobName" [disabled]="!resourceSelected" pInputText placeholder="name"
             type="text">
    </div>
  </div>

  <div *ngIf="!resourceSelected"><h3>{{messageOne}}</h3></div>
  <div *ngIf="resourceSelected&& !jobSelected"><h3>{{messageTwo}}</h3></div>
  <div *ngIf="!jobExists "><h3>{{messageThree}}</h3></div>
  <!--   SKELETTON -->

  <p-card *ngIf="jobSelected&&jobExists">
    <div><h3> Information</h3></div>
    <div class="ui-g">
      <div class="ui-g-2 ui-sm-6">Job :</div>
      <div class="ui-g-2 ui-sm-4"> --</div>
      <div class="ui-g-2 ui-sm-6">User :</div>
      <div class="ui-g-2 ui-sm-6"> --</div>
      <div class="ui-g-2 ui-sm-6">Number :</div>
      <div class="ui-g-2 ui-sm-6"> --</div>
    </div>
    <div class="text-center margin-top"><h4> Job Definition Atributes</h4></div>
    <div class="ui-g">
      <div class="ui-g-2 ">Job Description:</div>
      <div class="ui-g-10 "> --</div>
      <div class="ui-g-2 ">Library:</div>
      <div class="ui-g-10 "> --</div>
      <div class="ui-g-2 ">ASP device:</div>
      <div class="ui-g-10 "> --</div>
      <div class="ui-g-2">Job queue:</div>
      <div class="ui-g-10"> --</div>
    </div>
  </p-card>

  <p-card *ngIf="jobSelected&&jobExists" class="margin-top">
    <div><h3> Job Log</h3></div>
    <div class="ui-g">
      <div class="ui-g-2">From Module:</div>
      <div class="ui-g-10 "> --</div>
      <div class="ui-g-2 ">From Procedure:</div>
      <div class="ui-g-10 "> --</div>
      <div class="ui-g-2 ">Statement:</div>
      <div class="ui-g-10"> --</div>
      <div class="ui-g-2 ">To module:</div>
      <div class="ui-g-10 "> --</div>
      <div class="ui-g-2 ">To procedure:</div>
      <div class="ui-g-10 "> --</div>
      <div class="ui-g-2 ">Statement:</div>
      <div class="ui-g-10 "> --</div>
      <div class="ui-g-2 ">Message</div>
      <div class="ui-g-10 "> --</div>
      <div class="ui-g-2 ">Cause</div>
      <div class="ui-g-10 "> --</div>
      <div class="ui-g-2 ">Recovery</div>
      <div class="ui-g-10 "> --</div>

    </div>
  </p-card>

</div>
